module.exports = __webpack_public_path__ + "static/media/Easter.cea7d4e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/Easter.png
// module id = 1333
// module chunks = 3